import { FileAction } from "@/common/enums";
import { getListQuery } from "../queries";

export default {
  filterSchema: {
    fields: [
      {
        label: "Uploading user org",
        model: "uploadingUserOrg",
        type: "id-selector",
        queryName: "orgs",
        gqlQuery: getListQuery("Org"),
        placeholder: "Organization filter (none)",
        showSelected: false,
      },
      {
        label: "Action",
        model: "action",
        type: "inline-select",
        options: [
          { value: FileAction.OnboardOrg, label: "Onboard Org" },
          { value: FileAction.ImportECards, label: "Import ECards" },
          { value: FileAction.FetchECards, label: "Fetch ECards" },
          { value: FileAction.ClaimsBulkUpdate, label: "Bulk Update Claims" },
          { value: FileAction.BulkUpload, label: "Bulk Upload" },
          { value: FileAction.BulkDelete, label: "Bulk Delete" },
          { value: FileAction.PremiumDetails, label: "Premium Details" },
          { value: FileAction.SetUpOrgAndPolicies, label: "Process Closing Slip" },
          { value: FileAction.benefitsBulkAddition, label: "Benefits Bulk Addition" },
        ],
        showSelected: false,
      },
    ],
  },
};
